
export default function SaveButtonDirective() {
    'ngInject';
    return {
        template: require('./save-button.html'),
        transclude: true,
        restrict: 'E',
        scope: {
            edit: '=',
            disabled: '=',
            click: '&'
        }
    };
}
